export function filterDataByTripsAndAppendGeocodes(data) {
    const createMessageLayer = data.create_message_layer;
    const units = createMessageLayer.units;
    const getMessages = data.get_messages;
    const getGeocode = data.get_geocode;

    const filteredOutput = [];

    // Assuming there's at least one unit and it contains trips
    if (units && units.length > 0 && units[0].trips) {
        const trips = units[0].trips;

        trips.forEach((trip, tripIndex) => {
            const tripStartTime = trip.first.time;
            const tripEndTime = trip.last.time;

            const messagesForThisTrip = [];

            getMessages.forEach((message, msgIndex) => {
                const messageTimestamp = message.t;

                // Check if message timestamp is within the current trip's time range
                // (greater than or equal to 'first', and less than or equal to 'last')
                if (messageTimestamp >= tripStartTime && messageTimestamp <= tripEndTime) {
                    // Create a copy of the message object
                    const messageWithGeocode = { ...message };

                    // Append the corresponding geocode based on the message's original index
                    if (msgIndex < getGeocode.length) {
                        messageWithGeocode.geocode = getGeocode[msgIndex];
                    } else {
                        // If no geocode exists for this index, set to null or handle as needed
                        messageWithGeocode.geocode = null;
                    }
                    messagesForThisTrip.push(messageWithGeocode);
                }
            });

            filteredOutput.push({
                trip_index: tripIndex,
                trip_start_time: tripStartTime,
                trip_end_time: tripEndTime,
                trip_metadata: trip,
                filtered_messages_with_geocodes: messagesForThisTrip
            });
        });
    } else {
        console.log("No units or trips found in the provided data.");
    }

    return filteredOutput;
}
